<template>
    <div class="field-renderer-bool">
        <input
            ref="inputref"
            class="ag-input-field-input ag-checkbox-input"
            type="checkbox"
            :checked="value"
            readonly="true"
            disabled="true"
        />
    </div>
</template>
<script setup lang="ts">
import { ref } from 'vue';

const prop = withDefaults(
    defineProps<{
        value: boolean;
    }>(),
    { value: false },
);

const inputref = ref();

/**
 * Expose the focus method
 
 */
defineExpose({
    /**
     * Focus the input
     */
    focus: () => inputref.value?.focus(),
});
</script>
